export const usd = (v) => `${Number(v || 0).toLocaleString("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 3 })} $`;

export function ModelPicker({ models, value, onChange, count = 1 }) {
  return (
    <div className="grid gap-2 sm:grid-cols-3" role="radiogroup" data-testid="image-model-picker">
      {models.map((m) => (
        <button key={m.id} type="button" role="radio" aria-checked={value === m.id} onClick={() => onChange(m.id)} data-testid={`image-model-${m.id}`}
          className={`rounded-lg border p-3 text-left transition-colors ${value === m.id ? "border-sky-500 bg-sky-50/60 ring-1 ring-sky-500" : "border-slate-200 hover:border-slate-300"}`}>
          <span className="flex items-center justify-between gap-2">
            <span className="text-sm font-medium text-slate-900">{m.label}</span>
            <span className="text-xs font-semibold tabular-nums text-slate-700">{usd(m.usd * count)}</span>
          </span>
          <span className="mt-1 block text-[11px] text-slate-500">{m.note}{count > 1 ? ` · ${usd(m.usd)} per immagine` : " · per immagine"}</span>
        </button>
      ))}
    </div>
  );
}
